import { Fragment } from 'react'

import { useKeyboard } from '../../../hooks'
import { FormikForm } from '../../Formik'
import { GRETA_CHAT_TITLE_MAX_LENGTH } from '../GretaAIChat.constants'
import {
  getGretaAIChatNameFormInitialValues,
  GRETA_AI_CHAT_NAME_FORM_FIELD_NAME_NAME,
} from '../GretaAIChatNameField'

import { getGretaAIChatRenameModalValidationSchema } from './GretaAIChatRenameModal.utils'
import { GretaAIChatRenameModalForm } from './GretaAIChatRenameModalForm'

function GretaAIChatRenameModal({
  errorText,
  hasCounter = false,
  maxLength = GRETA_CHAT_TITLE_MAX_LENGTH,
  name,
  placeholder,
  qaName,
  title,
  onCancel,
  onSubmit,
}) {
  useKeyboard(null, onCancel)

  const initialValues = getGretaAIChatNameFormInitialValues(name)
  const validationSchema = getGretaAIChatRenameModalValidationSchema({
    initialValues,
    maxLength,
  })

  async function handleSubmit(
    { [GRETA_AI_CHAT_NAME_FORM_FIELD_NAME_NAME]: nextName },
    { setFieldError }
  ) {
    try {
      await onSubmit(nextName.trim())
    } catch {
      setFieldError(GRETA_AI_CHAT_NAME_FORM_FIELD_NAME_NAME, errorText)
    }
  }

  return (
    <FormikForm
      Component={Fragment}
      initialValues={initialValues}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      <GretaAIChatRenameModalForm
        hasCounter={hasCounter}
        maxLength={maxLength}
        placeholder={placeholder}
        qaName={qaName}
        title={title}
        validationSchema={validationSchema}
        onCancel={onCancel}
      />
    </FormikForm>
  )
}

export default GretaAIChatRenameModal
